<div class="save-panel__content">
  <form>
    <div>
      <label class="save-panel__label" for="projectName">{{ 'cfg_savePanel_subtitle_name' | translate }}</label>
    </div>
    <div>
      <input class="save-panel__input" type="text" (keyup)="projectNameError=false" [class.error]="projectNameError" name="projectName" [placeholder]="'cfg_savePanel_myproject' | translate" id="projectName" [(ngModel)]="projectName">
    </div>

    <div class="save-panel__listing">
      <div class="save-panel__label">{{ 'cfg_savePanel_subtitle_dir' | translate }}</div>
      <ul class="save-panel__directories">
        <li class="save-panel__directory" [ngClass]="{'save-panel__directory--selected': (currentFolder == noFolderLabel)}" (click)="setFolder(noFolderLabel)"><span class="text-button__icon icon icon-file-folder"></span> {{ 'cfg_noDirectory' | translate }}</li>
        <li class="save-panel__directory" *ngFor="let folder of userData.folders" [ngClass]="{'save-panel__directory--selected': (currentFolder == folder)}" (click)="setFolder(folder)"><span class="text-button__icon icon icon-file-folder"></span> {{ folder }}</li>
      </ul>
    </div>

    <div>
      <button class="text-button print-panel__button" (click)="createFolder()">
        <span class="text-button__icon icon icon-file-folder"></span>
        <span class="text-button__label">{{ 'cfg_save_newDir' | translate }}</span>
      </button>
    </div>

    <div class="save-panel__actions">
      <button class="button button--square" (click)='requestSaveProject()' >
        <span>{{ 'cfg_savePanel_validate' | translate }}</span>
      </button>
    </div>
  </form>

</div>

<app-modal id="modal-create-directory" width="640" [blocking]="false" #mcd>
  <p> 
    {{ 'cfg_save_newDir' | translate }}
  </p>

  <input class="save-panel__input" type="text" name="newFolderName" id="newFolderName" [(ngModel)]="newFolderName">

  <div class="modal__buttons">
    <button class="button button--square" (click)='registerFolder(newFolderName)' [disabled]="!newFolderName || newFolderName.length == 0">
      <span>{{ 'cfg_savePanel_validate' | translate }}</span>
    </button>
  </div>
</app-modal>

<app-modal id="modal-project-override" width="400" [blocking]="true" #mpo>
  <div [innerHtml]="'cfg_savePanel_overwrite' | translate"></div>

  <div class="modal__buttons">
    <button class="button button--square" (click)='mpo.close()'>
      <span>{{ 'btn_cancel' | translate }}</span>
    </button>

    <button class="button button--square" (click)='saveProject()'>
      <span>{{ 'cfg_continue' | translate }}</span>
    </button>
  </div>
</app-modal>

<app-modal id="modal-save-message" width="640" [blocking]="true" #msm>
  <p *ngIf="msm.data?.text" [innerHtml]="msm.data?.text | translate"></p>

  <div class="modal__buttons">
    <button class="button button--square" (click)='msm.close()'>
      <span>{{ 'btn_ok' | translate }}</span>
    </button>
  </div>
</app-modal>